import { useState, useEffect } from 'react';
import { API_BASE_URL, fetchWithCSRF } from '../config';

/**
 * Custom hook for managing next steps functionality
 */
export function useNextSteps(uuid, recommendations, emailSaved, contactEmail) {
  const [nextSteps, setNextSteps] = useState(null);
  const [loadingNextSteps, setLoadingNextSteps] = useState(false);
  const [nextStepsError, setNextStepsError] = useState(null);

  useEffect(() => {
    const fetchNextSteps = async () => {
      if (!uuid || !recommendations || !(emailSaved || contactEmail)) return;

      setLoadingNextSteps(true);
      setNextStepsError(null);

      try {
        const response = await fetch(`${API_BASE_URL}/api/universities/reports/${uuid}/next-steps/`);

        if (response.ok) {
          const data = await response.json();
          setNextSteps(data);
        } else {
          console.error('Failed to fetch next steps');
          setNextStepsError('Failed to load personalized next steps');
        }
      } catch (error) {
        console.error('Error fetching next steps:', error);
        setNextStepsError('Error loading next steps');
      } finally {
        setLoadingNextSteps(false);
      }
    };

    fetchNextSteps();
  }, [uuid, recommendations, emailSaved, contactEmail]);

  const refreshNextSteps = async () => {
    if (!uuid) return;

    try {
      const response = await fetchWithCSRF(`${API_BASE_URL}/api/universities/reports/${uuid}/next-steps/`, {
        method: 'POST'
      });

      if (response.ok) {
        const data = await response.json();
        setNextSteps(data);
        return true;
      }
      return false;
    } catch (error) {
      console.error('Error refreshing next steps:', error);
      return false;
    }
  };

  return {
    nextSteps,
    setNextSteps,
    loadingNextSteps,
    nextStepsError,
    refreshNextSteps
  };
}